import ApiClient from './ApiClient';

class CustomMenuAPI extends ApiClient {
  constructor() {
    super('custom_menus', { accountScoped: true });
  }
}

export default new CustomMenuAPI();
